import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import media from 'media'

import SplitContainer, { Row } from './'

const TextContainer = styled.div`
  && {
    margin-bottom: 30px;
  }
`

const StyledSplitContainer = styled(SplitContainer)`
  ${media.desktop`
    ${Row} > *:first-child:has(${TextContainer}) {
      margin-right: 50px;
    }

    ${Row} > *:nth-child(2):has(${TextContainer}) {
      margin-left: 50px;
    }
  `}
`

/**
 * for a 2 column, alternating layout
 * vertical for mobile - tablet, horizontal for desktop+
 */
export default function OpinionatedSplitContainer ({
  textColumn: { width: textWidth, itemsToRender: textItems },
  assetColumn: { width: assetWidth, itemsToRender: assetItems },
  startWithAsset,
  mobileStartWithAsset,
  orientation,
  mobileOrientation,
  ...others
}) {
  // TODO: validate items arrays here

  const rows = textItems.map((item, index) => {
    const textObject = {
      width: textWidth,
      renderChildren: () => <TextContainer as={item} />,
    }
    const assetObject = {
      width: assetWidth,
      renderChildren: () => assetItems[index](),
    }

    return [textObject, assetObject]
  })

  return (
    <StyledSplitContainer
      rows={rows}
      orientation={orientation}
      mobileOrientation={mobileOrientation}
      mobileStartsWith={mobileStartWithAsset ? 'asset' : 'text'}
      startsWith={startWithAsset ? 'asset' : 'text'}
      {...others}
    />
  )
}

OpinionatedSplitContainer.defaultProps = {
  orientation: 'swapped',
}

OpinionatedSplitContainer.propTypes = {
  textColumn: PropTypes.shape({
    width: PropTypes.number,
    itemsToRender: PropTypes.arrayOf(PropTypes.node),
  }),
  assetColumn: PropTypes.shape({
    width: PropTypes.number,
    itemsToRender: PropTypes.arrayOf(PropTypes.node),
  }),
  startWithAsset: PropTypes.bool,
  mobileStartWithAsset: PropTypes.bool,
  orientation: PropTypes.oneOf(['straight', 'swapped']),
  mobileOrientation: PropTypes.oneOf(['straight', 'swapped']),
}
